.input:focus {
  border-color: #ff00bf;
}
